module.exports = __webpack_public_path__ + "img/icon_map_102_off.53c03db3.png";